import { Component } from '@angular/core';
import { BroadcasterService } from '../services/broadcaster.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {

  constructor(private broadcast: BroadcasterService) { }

  menuEvent() {
    this.broadcast.fire('openMenuEvent');
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/navbar.component.ts